import React from "react";

import { styled } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";
import { green } from "@mui/material/colors";

const Wrapper = styled(Grid)(()=>({
  margin: 16,
  position: "relative",
}));

const FabProgress = styled(CircularProgress)(()=>({
  color: green[500],
  position: "absolute",
  top: -6,
  left: -6,
  zIndex: 1,
}));

export const SearchLoader = () => {
  // const classes = useStyles();
  return (
    <Wrapper>
      <Fab aria-label="save" color="primary">
        <SearchIcon />
      </Fab>
      <FabProgress size={68}/>
    </Wrapper>
  );
};
